import React from "react";
import { Link } from "react-router-dom";

const MODULES = [
  {
    key: "profile",
    icon: "PR",
    title: "ASAP Profile",
    desc: "Sourcing automatisé : transformez chaque appel d'offres en shortlist enrichie de profils ciblés.",
    kicker: "Sourcer plus vite",
    href: "/modules/asap-profil",
  },
  {
    key: "partners",
    icon: "PA",
    title: "ASAP Partners",
    desc: "Gardez une vision exploitable de votre réseau partenaire pour répondre plus largement aux besoins clients.",
    kicker: "Étendre la capacité",
    href: "/modules/asap-partners",
  },
  {
    key: "skills",
    icon: "SK",
    title: "ASAP Skills",
    desc: "Cartographiez les compétences pour mieux identifier les expertises disponibles et les écarts à combler.",
    kicker: "Lire le potentiel",
    href: "/modules/asap-skills",
  },
  {
    key: "pilot",
    icon: "PI",
    title: "ASAP Pilot",
    desc: "Pilotez les opportunités, besoins, shortlists et actions commerciales depuis une vision plus claire.",
    kicker: "Accélérer le suivi",
    href: "/modules/asap-pilot",
  },
  {
    key: "cv",
    icon: "CV",
    title: "ASAP CV",
    desc: "Centralisez, harmonisez et préparez des CV professionnels, plus faciles à exploiter pour vos réponses clients.",
    kicker: "Standardiser la qualité",
    href: "/modules/asap-cv",
  },
];

const Modules = () => (
  <section className="mk-section soft" id="modules" data-testid="section-modules">
    <div className="mk-wrap">
      <div className="mk-section-head mk-reveal">
        <div>
          <h2>Un hub modulaire pour couvrir tout le cycle : du recrutement à la signature</h2>
        </div>
      </div>
      <div className="mk-features">
        {MODULES.map((m) => (
          <Link key={m.key} to={m.href} className="mk-feature mk-reveal" data-testid={`module-card-${m.key}`}>
            <div className="mk-icon">{m.icon}</div>
            <h3>{m.title}</h3>
            <p>{m.desc}</p>
            <small>{m.kicker} →</small>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default Modules;
